import _Promise from 'babel-runtime/core-js/promise';
import { adminSystemIndexAPI } from '@/api/admin/config';
import { crmSettingConfigDataAPI } from '@/api/admin/crm';
import { configHeaderModelSortAPI } from '@/api/config';
import Lockr from 'lockr';

/** 记录 侧边索引 */
var app = {
  state: {
    logo: '',
    name: '',
    lang: localStorage.lang || 'cn',
    sidebar: {
      activeIndex: '', // 目前激活的 行
      collapse: Lockr.get('sideBarCollapse') || false
    },
    navbar: {
      activeIndex: '' // 导航目前是第几个 个人中心需要
    },
    // CRM配置信息
    CRMConfig: {},
    // 图片缓存
    imageCache: {},
    headerModule: null // 置顶模块
  },

  mutations: {
    SET_ACTIVEINDEX: function SET_ACTIVEINDEX(state, path) {
      state.sidebar.activeIndex = path;
    },
    SET_COLLAPSE: function SET_COLLAPSE(state, collapse) {
      state.sidebar.collapse = collapse;
      Lockr.set('sideBarCollapse', collapse);
    },
    SET_NAVACTIVEINDEX: function SET_NAVACTIVEINDEX(state, path) {
      state.navbar.activeIndex = path;
    },
    SET_APPLOGO: function SET_APPLOGO(state, logo) {
      state.logo = logo;
    },
    SET_APPNAME: function SET_APPNAME(state, name) {
      state.name = name;
    },
    SET_LANG: function SET_LANG(state, lang) {
      state.lang = lang;
      window.app.$i18n.locale = lang;
      localStorage.setItem('lang', lang);
      window.location.reload();
    },
    SET_CRMCONFIG: function SET_CRMCONFIG(state, config) {
      state.CRMConfig = config;
    },
    SET_IMAGECACHE: function SET_IMAGECACHE(state, value) {
      state.imageCache = value;
    }
  },

  actions: {
    // 登录
    SystemLogoAndName: function SystemLogoAndName(_ref) {
      var commit = _ref.commit;

      return new _Promise(function (resolve, reject) {
        adminSystemIndexAPI().then(function (response) {
          commit('SET_APPNAME', response.data.name);
          commit('SET_APPLOGO', response.data.logo);
          Lockr.set('systemLogo', response.data.logo);
          Lockr.set('systemName', response.data.name);
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },


    /**
     * 获取客户管理配置
     */
    CRMSettingConfig: function CRMSettingConfig(_ref2) {
      var commit = _ref2.commit;

      return new _Promise(function (resolve, reject) {
        crmSettingConfigDataAPI().then(function (response) {
          commit('SET_CRMCONFIG', response.data);
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    },


    // 置顶应用
    WKHeaderModule: function WKHeaderModule(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state;

      return new _Promise(function (resolve, reject) {
        configHeaderModelSortAPI().then(function (response) {
          state.headerModule = response.data || [];
          resolve(response);
        }).catch(function (error) {
          state.headerModule = [];
          reject(error);
        });
      });
    }
  }
};

export default app;